import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import confirm from 'components/parts/item/confirmationModal';
import { getProgramFiles } from 'actions/programFileAction';
import { setMessage, clearMessage } from 'actions/messageAction';
import { deleteProgramSetting } from 'actions/programSettingAction';
import { convertTimestampToDate } from 'helpers';
import { lang } from 'lang';
import { IconButton } from 'styles/util';

/**
 * 調整プログラム設定の行を表示するコンポーネント
 */
const Setting = (props) => {
  const { msg, error } = lang;
  const { item } = props;
  const [ buttonStatus, setButtonStatus ] = React.useState(false);
  const dispatch = useDispatch();
  /**
   * 削除ボタンが押下されたときに実行するメソッド
   */
  const clickDeleteButton = async productCode => {
    const result = await confirm({
      body: msg.custom_file.confirm_remove.replace('%s', productCode),
    });
    if (result) {
      // メッセージ初期化
      dispatch(clearMessage());

      // 削除ボタンを非活性
      setButtonStatus(true);

      // プログラムファイルを一覧取得する
      await dispatch(
        await getProgramFiles()
      ).then(async (result) => {
        // ERROR
        if (result.status === 200) {
          // 既にバージョンが存在する場合は、エラーメッセージを表示する
          for (const key in result.items) {
            const tmpArry = result.items[key].key.split('_'); // プログラムファイルは、filename_versionの形式になっている
            if (tmpArry.length === 2 && tmpArry[0] === item.filename) {
              dispatch(setMessage('danger', error.custom_file.not_remove));
              return false;
            }
          }

          await dispatch(
            // 対象の調整プログラム設定を削除する
            await deleteProgramSetting(productCode)
          ).then((result) => {
            // Success
            if (result.status === 200) {
              dispatch(setMessage('success', msg.custom_file.remove));
            // Error
            } else {
              dispatch(setMessage('danger', error.custom_file.remove + `\n${result.errcode}`));
            }
          });
        } else {
          dispatch(setMessage('danger', error.custom_file.remove + `\n${result.errcode}`));
        }
      });
      // 削除ボタンを活性化
      setButtonStatus(false);
    }
  };
  return (
    <tr>
      <td>
        <Link to={`/srv/setting/detail/${item.product_cd}`}>
          {item.product_cd}
        </Link>
      </td>
      <td>{item.destination}</td>
      <td>{item.model}</td>
      <td>{item.alias}</td>
      <td>{item.filename}</td>
      <td>{convertTimestampToDate(item.updated_at)}</td>
      <td>
        <IconButton>
          <Link to={`/srv/setting/edit/${item.product_cd}`} style={{color: 'black'}}>
            <i className="fa fa-edit" aria-hidden="true"></i>
          </Link>
        </IconButton>
      </td>
      <td>
        <IconButton disabled={buttonStatus} onClick={() => clickDeleteButton(item.product_cd)}>
          <i className="fa fa-trash" aria-hidden="true"></i>
        </IconButton>
      </td>
    </tr>  
  );
};
Setting.propTypes = {
  item: PropTypes.object
};
Setting.defaultProps = {
  item: {
    product_cd: '',
    destination: '',
    model: '',
    alias: '',
    filename: '',
    created_at: '',
  }
};
export default Setting;
